import { useCallback } from 'react'

import { LoggerKey } from '@config/logger'

import { useBasin } from '@hooks/useBasin'
import useLogger from '@hooks/useLogger'

interface ProductClickFieldsToValidate {
    category: string
    clickId: string
    customerId?: string
    productCode?: string
    scoreId?: string
}

interface ResultScreenDisplayedFieldsToValidate {
    category: string
    customerId?: string
    scoreId?: string
}

const useLogMissingProductClickFields = () => {
    const { logInfo } = useLogger()
    const { ids } = useBasin()

    const logMissingProductClickFields = useCallback(
        ({
            category,
            clickId,
            customerId,
            productCode,
            scoreId,
        }: ProductClickFieldsToValidate): void => {
            const sessionId = ids?.sessionId
            const missingFields: string[] = []

            if (!customerId) missingFields.push('customerId')
            if (!scoreId) missingFields.push('scoreId')
            if (!productCode) missingFields.push('productCode')
            if (!clickId) missingFields.push('clickId')
            if (!sessionId) missingFields.push('sessionId')

            if (missingFields.length > 0) {
                logInfo(LoggerKey.ProductClick, {
                    message: 'Missing data',
                    missingFields,
                    category,
                    customerId,
                    scoreId,
                    productCode,
                    clickId,
                    sessionId,
                })
            } else {
                logInfo(LoggerKey.ProductClick, {
                    category,
                    customerId,
                    scoreId,
                    productCode,
                    clickId,
                    sessionId,
                })
            }
        },
        [logInfo]
    )

    const logMissingResultScreenDisplayedFields = useCallback(
        ({
            category,
            customerId,
            scoreId,
        }: ResultScreenDisplayedFieldsToValidate): void => {
            const sessionId = ids?.sessionId
            const missingFields: string[] = []

            if (!customerId) missingFields.push('customerId')
            if (!scoreId) missingFields.push('scoreId')
            if (!sessionId) missingFields.push('sessionId')

            if (missingFields.length > 0) {
                logInfo(LoggerKey.ResultScreenDisplayed, {
                    message: 'Missing data',
                    missingFields,
                    category,
                    customerId,
                    scoreId,
                    sessionId,
                })
            } else {
                logInfo(LoggerKey.ResultScreenDisplayed, {
                    category,
                    customerId,
                    scoreId,
                    sessionId,
                })
            }
        },
        [logInfo]
    )

    return {
        logMissingProductClickFields,
        logMissingResultScreenDisplayedFields,
    }
}

export default useLogMissingProductClickFields
